<template>
  <div class="prompt-container">
    <!-- 加载层 -->
    <van-overlay v-show="loading" class="loading-overlay">
      <div class="loading-content">
        <van-loading type="spinner" color="#fff" />
        <p class="loading-text">生成中...</p>
      </div>
    </van-overlay>

    <div class="layout">
      <!-- 左侧/上方：搜索区 -->
      <div class="panel-left">
        <div class="form-area">
          <div class="form-row" v-for="field in fields" :key="field.key">
            <label class="field-label">{{ field.label }}</label>
            <div class="field-input-wrap">
              <template v-if="field.type === 'switch'">
                <van-switch v-model="form[field.key]" size="20px" />
              </template>
              <template v-else>
                <van-field v-model="form[field.key]" :placeholder="field.label" class="field-input" />
                <span v-if="field.hint" class="field-hint">{{ field.hint }}</span>
              </template>
            </div>
          </div>
        </div>
        <div class="btn-zone">
          <van-button @click="handleGenerate" round type="primary" :disabled="loading">生成提示词</van-button>
        </div>
      </div>

      <!-- 右侧/下方：结果区 -->
      <div class="panel-right">
        <div v-if="promptResult" class="result-area">
          <div class="result-header">
            <span class="result-title">生成结果</span>
            <van-button @click="handleCopy" round type="default" class="copy-btn">{{ copied ? '已复制' : '复制' }}</van-button>
          </div>
          <pre class="result-text">{{ promptResult }}</pre>
        </div>
        <div v-else class="result-placeholder">提示词将在此处显示</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Button, Overlay, Loading, Notify, Switch } from 'vant';

export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Switch.name]: Switch,
  },
  data() {
    return {
      loading: false,
      copied: false,
      promptResult: '',
      fields: [
        { key: 'name_keywords', label: '名字关键字' },
        { key: 'stock_name',    label: '对标名称',  hint: '股票名称' },
        { key: 'business',      label: '涉及业务',  hint: '名称含关键字（化工、食品、航天、医药、高铁）' },
        { key: 'association',   label: '开启联想',  type: 'switch' },
        { key: 'company_name',  label: '检索公司',  hint: '张雪机车' },
        { key: 'address',       label: '公司所在地' },
        { key: 'biz_area',      label: '业务地区' },
        { key: 'concept',       label: '概念' },
        { key: 'holder',        label: '股东' },
        { key: 'hot_words',     label: '附加热点',  hint: '近期热点概念（加分项）' },
      ],
      form: {
        name_keywords: '',
        business: '',
        association: true,
        address: '',
        biz_area: '',
        concept: '',
        holder: '',
        stock_name: '',
        company_name: '',
        hot_words: '',
      },
    };
  },
  methods: {
    handleGenerate() {
      this.loading = true;
      this.copied = false;
      this.$axios.post('/api/openclaw/kurong/prompt', this.form)
        .then(response => {
          this.loading = false;
          if (response.data.code === '0') {
            this.promptResult = response.data.data;
          } else {
            Notify({ type: 'warning', duration: 3000, message: `生成失败：${response.data.data}` });
          }
        })
        .catch(error => {
          this.loading = false;
          Notify({ type: 'danger', duration: 3000, message: error.message || '网络异常' });
        });
    },
    handleCopy() {
      if (!this.promptResult) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.promptResult).then(() => {
          this.copied = true;
          setTimeout(() => { this.copied = false; }, 2000);
        });
      } else {
        const ta = document.createElement('textarea');
        ta.value = this.promptResult;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      }
    },
  },
};
</script>

<style lang="less">
.prompt-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.06);
  font-size: 13px;
}

/* PC：左右布局 */
.layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.panel-left {
  flex: 0 0 420px;
}

.panel-right {
  flex: 1;
  min-width: 0;
}

/* H5：上下布局 */
@media (max-width: 768px) {
  .prompt-container {
    max-width: 100%;
  }
  .layout {
    flex-direction: column;
    gap: 0;
  }
  .panel-left {
    flex: none;
    width: 100%;
  }
  .panel-right {
    width: 100%;
    margin-top: 12px;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
  }
}

.form-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.field-label {
  flex: 0 0 72px;
  font-size: 12px;
  font-weight: 500;
  color: #333;
  text-align: right;
  white-space: nowrap;
}

.field-input {
  flex: 1;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  background: #fafafa;
}

.field-input-wrap {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.field-hint {
  font-size: 11px;
  color: #bbb;
  padding-left: 4px;
  line-height: 1.4;
}

.btn-zone {
  display: flex;
  justify-content: center;
  padding: 14px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 12px;
}

.result-area {
  height: 100%;
}

.result-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.result-title {
  font-size: 13px;
  font-weight: 600;
  color: #333;
}

.copy-btn {
  height: 30px !important;
  padding: 0 14px !important;
  font-size: 13px !important;
}

.result-text {
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 12px;
  line-height: 1.7;
  color: #444;
  background: #f7f8fa;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 12px;
  margin: 0;
}

.result-placeholder {
  color: #bbb;
  font-size: 12px;
  text-align: center;
  padding: 40px 0;
  border: 1px dashed #e8e8e8;
  border-radius: 4px;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0,0,0,0.5);
}

.loading-content {
  text-align: center;
  color: #fff;
  background: rgba(0,0,0,0.7);
  padding: 15px 25px;
  border-radius: 6px;
}

.loading-text {
  margin-top: 8px;
  font-size: 13px;
}
</style>
